export const SUGGEST_QUESTION_Q = /* GraphQL */ `
  query SuggestQuestion {
    suggestQuestion {
      id
      dimensionId
      source
      suggestedCopy
      rationale
      script {
        rootId
        nodes {
          id
          prompt
          kind
          allowOther
          options {
            id
            label
            kind
            nextNodeId
            extracts
          }
        }
      }
    }
  }
`;

export const RECORD_ANSWER_M = /* GraphQL */ `
  mutation RecordQuestionAnswer($input: RecordAnswerInput!) {
    recordQuestionAnswer(input: $input) {
      answerId
      extracted
    }
  }
`;
